export const authStorageKey = 'auth';